import { AssessmentType } from "types/graphql-schema";

import ManagerEffectivenessReport from "@apps/reporting/components/manager-effectiveness-report";
import PerformanceAssessmentReport from "@apps/reporting/components/performance-assessment-report";

const AssessmentReportTab = ({
  complianceProgramId,
  assessmentType,
}: {
  complianceProgramId: number;
  assessmentType: AssessmentType;
}) => {
  return (
    <div>
      {assessmentType === AssessmentType.Performance ? (
        <PerformanceAssessmentReport
          complianceProgramId={complianceProgramId}
          headerContent={(settings) => <div className="pb-6">{settings}</div>}
          isInReporting={false}
        />
      ) : (
        <ManagerEffectivenessReport
          complianceProgramId={complianceProgramId}
          headerContent={(settings) => <div className="pb-6">{settings}</div>}
          isInReporting={false}
        />
      )}
    </div>
  );
};

export default AssessmentReportTab;
